import $api from '../services';

export default {
    getRefreshTime() {
        return $api.get('/refresh_period', {
            tab: 'watchlist',
        });
    },
    setRefreshTime(val) {
        return $api.get('/refresh_period', {
            tab: 'watchlist',
            period: val,
        });
    },
    getMarketData() {
        return $api.get('/market_data');
    },
    getGraphData() {
        return $api.get('/graph_data');
    },
    getMarketFields() {
        return $api.get('/pull_list_config', {
            tab: 'market_watchlist',
        });
    },
    getMarketGraphFields() {
        return $api.get('/pull_list_config', {
            tab: 'graph_watchlist',
        });
    },
    getSymbologies() {
        return $api.get('/get_symbologies');
    },
    hasSavedCredentials() {
        return $api.get('/has_tt_fix_password');
    },
    updateMarketFields(params) {
        params = JSON.stringify(params);
        return $api.get('/update_list_config', {
            tab: 'market_watchlist',
            config_body: params,
        });
    },
    updateMarketGraphFields(params) {
        params = JSON.stringify(params);
        return $api.get('/update_list_config', {
            tab: 'graph_watchlist',
            config_body: params,
        });
    },
    saveMarketCredentials(data) {
        const payload = new FormData();
        payload.append('tt_fix_password', JSON.stringify(data));
        return $api.post('/set_tt_fix_password', payload);
    },
    getMarketCredentials(symbologie, prefix) {
        return $api.get(`/symbols_by_prefix/${symbologie}/${prefix}`);
    },
};
